<template>
  <main>
    <b-container>
      <div class="section-header">
        <h1 class="heading">About</h1>
        <div class="action"></div>
      </div>

      <div class="layoutcard">
        <table class="table table-hover vertical-align-middle">
          <tbody>
            <tr>
              <th width="50%">Build</th>
              <td>
                &ndash;
                <!-- TODO: Fetch recent tag from Git Api -->
                &nbsp;{{this.version}}
              </td>
            </tr>
            <tr>
              <th>Last update</th>
              <td>
                &ndash;
                <!-- TODO: Fetch date for last commit from Git Api -->
                &nbsp;{{this.deployedAt}}
              </td>
            </tr>
            <tr>
              <td colspan="2">
                Developed in cooperation with Creax, Coldstone, MMEC, T.I.P.P, Jelle Demeulemeester
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </b-container>
  </main>
</template>
<script>
import InitAdmin from "../Shared/InitAdmin";

export default {
  name: "About",
  extends: InitAdmin,
  data() {
    return {
      version: "",
      deployedAt: "",
    };
  },
  computed: {},
  methods: {},
  mounted() {
    this.version = process.env.VUE_APP_RELEASE;
    this.deployedAt = process.env.VUE_APP_DEPLOY_AT;
  },
};
</script>
